import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import queryString from "query-string"

import { N0DES_API_PREFIX } from "@/api/domain"
import type { Interval } from "@/metrics"
import type { IrohDeployInfo, ProjectIdParam } from "@/types"
import { formatDateWithoutMillsecondsAndZ } from "@/util"
import { basename } from "@sentry/core"

// Define a service using a base URL and expected endpoints
export const dnsApi = createApi({
  reducerPath: "dns",
  baseQuery: fetchBaseQuery({
    baseUrl: `${N0DES_API_PREFIX}dns`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    dnsGet: build.query<IrohDeployInfo[], ProjectIdParam>({
      query: (params) => ({
        url: `${params.project_id}`,
      }),
    }),
  }),
})

export const { useDnsGetQuery } = dnsApi
